import BottomInfoPopup from './InfoPopup'
import CanvasNavBar from './CanvasNavBar'
import ContextMenu from './ContextMenu'
import DisplayFiles from './DisplayFiles'
import FloatingControls from './FloatingControls'
import SearchAI from './SearchAI.vue'
import MainHeader from './MainHeader'
import NotificationBar from './NotificationBar'
import PolyglotQueries from './PolyglotQueries'
import PostIt from './PostIt'
import ProfileMenu from './ProfileMenu'
import QueryNameInput from './QueryNameInput'
import ResultsSection from './ResultsContainer/ResultsIframe'

export {
  BottomInfoPopup,
  CanvasNavBar,
  ContextMenu,
  DisplayFiles,
  FloatingControls,
  SearchAI,
  MainHeader,
  NotificationBar,
  PolyglotQueries,
  PostIt,
  ProfileMenu,
  QueryNameInput,
  ResultsSection
}



// WEBPACK FOOTER //
// ./src/components/parts/index.js